import classNames from "classnames/bind";
import SmartLink from "common/wrapper/SmartLink";
import useHasMounted from "hooks/useHasMounted/useHasMounted";

import styles from "./Breadcrumbs.module.scss";

const cx = classNames.bind(styles);

interface BreadcrumbProps {
    href?: string;
    title: string;
    lastItem?: boolean;
    prefetch?: boolean;
}

export interface BreadcrumbsProps {
    breadcrumbs?: Array<BreadcrumbProps>;
    prefetch?: boolean;
}

const BreadcrumbItem: React.FC<BreadcrumbProps> = ({ href, title, lastItem, prefetch = false }) => {
    const hasMounted = useHasMounted();

    let url = href || "";

    if (hasMounted) {
        const absoluteUrl = window.location.origin;

        if (url && !url?.includes(absoluteUrl)) {
            url = absoluteUrl + url;
        }
    }

    if (url && !lastItem) {
        return (
            <SmartLink href={url} prefetch={!!prefetch}>
                <a className={cx("title", "link")} itemProp="item">
                    <span itemProp="name">{title}</span>
                </a>
            </SmartLink>
        );
    }

    return (
        <span aria-current="page" className={cx("title", "current")}>
            <span itemProp="name">{title}</span>
        </span>
    );
};

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ breadcrumbs, prefetch = false }) => (
    <nav aria-label="Breadcrumb" className={cx("breadcrumbs")}>
        <ol className={cx("list")} itemScope itemType="https://schema.org/BreadcrumbList">
            {breadcrumbs?.map((breadcrumb, i) => {
                return (
                    <li
                        className={cx("listItem")}
                        itemProp="itemListElement"
                        itemScope
                        itemType="https://schema.org/ListItem"
                        key={i}
                    >
                        <BreadcrumbItem
                            prefetch={!!prefetch}
                            lastItem={i === breadcrumbs.length - 1}
                            {...breadcrumb}
                        />
                        <meta itemProp="position" content={String(i + 1)} />
                    </li>
                );
            })}
        </ol>
    </nav>
);

export default Breadcrumbs;
